import api from './api'

export const songService = {
  // Get songs with pagination
  async getSongs(page = 1, pageSize = 20) {
    const response = await api.get('/song', {
      params: { page, pageSize }
    })
    return response.data
  },

  // Get song by ID
  async getSongById(id) {
    const response = await api.get(`/song/${id}`)
    return response.data
  },

  // Get popular songs
  async getPopularSongs(limit = 10) {
    const response = await api.get('/song/popular', {
      params: { limit }
    })
    return response.data
  },

  // Create new song
  async createSong(song) {
    const response = await api.post('/song', song)
    return response.data
  },

  // Add song to playlist
  async addSongToPlaylist(songId, playlistId) {
    await api.post(`/song/${songId}/add-to-playlist/${playlistId}`)
  },

  // Remove song from playlist
  async removeSongFromPlaylist(songId, playlistId) {
    await api.delete(`/song/${songId}/remove-from-playlist/${playlistId}`)
  },

  // Update play count
  async updatePlayCount(songId) {
    try {
      const response = await api.post(`/song/${songId}/play`)
      return response.data
    } catch (error) {
      console.error('Failed to update play count:', error)
      throw error
    }
  },

  // Get user's play history (for personalized popular songs)
  async getUserPlayHistory(limit = 10) {
    try {
      const response = await api.get('/song/play-history', {
        params: { limit }
      })
      return response.data
    } catch (error) {
      console.warn('Play history API not available, falling back to popular songs:', error.response?.status)
      // API가 구현되지 않았거나 인증 실패시 일반 인기곡 반환
      return await this.getPopularSongs(limit)
    }
  }
}